var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavoriteOffNav(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "favoritesOff",
    d: "M11 1L8.22 6.924 2 7.874l4.5 4.613L5.44 19 11 15.925l5.562 3.074-1.061-6.512L20 7.874l-6.22-.95L11 1zm3.46 5.016l5.691.87a1 1 0 0 1 .565 1.687l-4.147 4.251.98 6.014a1 1 0 0 1-1.47 1.036L11 17.067l-5.078 2.807a1 1 0 0 1-1.47-1.036l.98-6.014-4.148-4.251a1 1 0 0 1 .565-1.687l5.692-.87L10.095.575a1 1 0 0 1 1.81 0l2.554 5.441z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10-10h40v40h-40z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "nonzero",
    transform: "translate(-1)",
    xlinkHref: "#favoritesOff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteOffNav);
export default __webpack_public_path__ + "static/media/favorite-off-nav.ac80fda4.svg";
export { ForwardRef as ReactComponent };